<template>
  <div class="allRequirement">
    <div class="searchBox" v-if="showSearch">
      <el-input
        class="searchInput"
        size="small"
        v-model="productName"
        @keyup.native="changeProductInfo"
        placeholder="输入关键字"
        suffix-icon="el-icon-search"
      >
      </el-input>
    </div>
    <div class="serviceListMessage_box">
      <div
        class="hotMesg_box"
        v-for="(item, index) in tableList"
        :key="index"
      >
        <p class="hotMesg_box_title ellipsis-1">{{ item.demandName }}</p>
        <p
          class="hotMesg_icons"
          :style="{ backgroundImage: `url(${imgs1})` }"
          v-if="
            item.status != 'DRAFT' &&
            item.status != 'AUDIT' &&
            item.status != 'REJECT' &&
            item.status != 'CANCEL'
          "
        >
          进行中
        </p>
        <p
          class="hotMesg_icons"
          :style="{ backgroundImage: `url(${imgs2})` }"
          v-if="
            item.status != 'DRAFT' &&
            item.status != 'AUDIT' &&
            item.status != 'REJECT' &&
            item.status != 'CANCEL' &&
            item.status != 'UN_OFFERD'
          "
        >
          已对接
        </p>
        <p
          class="hotMesg_icons"
          :style="{ backgroundImage: `url(${imgs3})` }"
          v-if="item.status == 'END'"
        >
          已截止
        </p>
        <p
          class="hotMesg_icons2"
          :style="{ backgroundImage: `url(${imgs3})` }"
          v-if="item.status == 'CANCEL'"
        >
          已取消
        </p>
        <div class="hotMesg_box_content">
          <p>
            <span>需求方：</span>
            <span>{{ item.creatorName }}</span>
          </p>
          <p>
            <span>类型：</span>
            <span>{{ item.demandTypeCn }}</span>
          </p>
        </div>
        <div class="hotMesg_box_bot">
          <div class="hotMesg_box_botMesg">
            <p class="hotMesg_box_botMesgP">发布时间</p>
            <p>
              {{
                item.publishTime
                  ? moment(item.publishTime).format("YYYY-MM-DD")
                  : ""
              }}
            </p>
          </div>
          <div class="hotMesg_box_botMesg" v-if="item.secondBidding == 1">
            <p class="hotMesg_box_botMesgP">截止时间</p>
            <p>{{ item.deadlineSecond }}</p>
          </div>
          <div class="hotMesg_box_botMesg" v-else>
            <p class="hotMesg_box_botMesgP">截止时间</p>
            <p>{{ item.deadline }}</p>
          </div>
        </div>
        <div class="budget" :class="item.budgerClass">
          <div class="budget_mbox">
            <p>预算金额：</p>
            <h2 class="budget_m" v-if="item.budgetType == 0">
              {{ item.budgetPrice }}
            </h2>
            <h2 class="budget_m" v-else-if="item.budgetType == 1">
              {{ item.budgetMin + "-" + item.budgetMax }}
            </h2>
            <h2 class="budget_m" v-else>无预算</h2>
          </div>
          <p class="budget_btn" @click="gotoBudget(item.id)">
            {{ item.status == "UN_OFFERD" ? "去报价" : "去详情" }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="tableList.length==0" style="text-align:center;margin-bottom:20px" >
        <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
    </div>
    <div style="text-align: right" v-if="showPage">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    showSearch:{
      type:Boolean,
      default:true
    },
    tableList:{
      type:Array,
      default:[]
    },
    showPage:{
      type:Boolean,
      default:true
    },
    total:{
      type:Number,
      default:0,
    }
  },
  data() {
    return {
      current: 1,
      pageSize: 9,
      productName: "",
      imgs1: require("@/assets/supplyHome/green.jpg"),
      imgs2: require("@/assets/supplyHome/yellow.jpg"),
      imgs3: require("@/assets/supplyHome/gray.jpg"),
    };
  },
  methods: {
    changeProductInfo() {
      this.current = 1;
       this.$emit('handleQueryChange',{current:this.current,pageSize:this.pageSize,productName:this.productName})
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      this.$emit('handleQueryChange',{current:this.current,pageSize:this.pageSize,productName:this.productName})
    },
    gotoBudget(uuid) {
      let routeData = this.$router.resolve({
        path: `/demandDetails?uuid=${uuid}`,
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.ellipsis-1 {
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
}
.allRequirement {
  margin-top: 30px;
  .searchBox {
    background-color: #fafcff;
    height: 50px;
    line-height: 50px;
    margin: 30px 0 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    .searchInput {
      width: 20%;
    }
    .searchInput /deep/ .el-input__inner {
      border-radius: 30px;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }

    /deep/ .el-form-item__label {
      line-height: inherit;
    }

    /deep/ .el-form-item__content {
      line-height: inherit;
    }

    .el-cascader /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .serviceListMessage_box {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    grid-gap: 8px;
    margin-bottom: 40px;
  }
  .hotMesg_box {
    border-radius: 4px;
    background: #fff;
    position: relative;
    .hotMesg_icons {
      position: absolute;
      right: -6px;
      top: 35%;
      background-size: 100% 100%;
      padding: 3px 15px;
      font-size: 12px;
      color: #fff;
    }
    .hotMesg_icons2 {
      position: absolute;
      right: -0;
      top: 35%;
      width: 40px;
      height: 50px;
      background-size: 100% 100%;
      padding: 3px 15px;
      font-size: 12px;
      color: #fff;
    }
    .hotMesg_box_title {
      font-size: 16px;
      padding: 12px 20px 10px 14px;
      border-bottom: 1px solid #ededed;
      font-weight: 600;
      color: #333333;
    }
    .hotMesg_box_content {
      font-size: 14px;
      padding: 8px 12px 0;
      line-height: 32px;
      color: #333333;
      .red {
        color: #d9001b;
      }
    }
    .hotMesg_box_bot {
      display: grid;
      grid-template-columns: 50% 50%;
      margin: 20px 6px;
      margin-bottom: 0;
      background: #fafafc;
      padding: 4px 0;

      .hotMesg_box_botMesg {
        font-size: 12px;
        padding: 6px;
        text-align: center;
        display: flex;
        align-items: center;
        color: #333333;
        .hotMesg_box_botMesgP {
          color: #999999;
          font-weight: 400;
          margin-right: 6px;
        }
      }
    }
    .budget {
      border-top: 1px solid #ededed;
      margin-bottom: 8px;
      display: flex;
      margin-top: 16px;
      padding-top: 11px;
      align-items: center;
      .budget_mbox {
        margin: 0 auto;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        .budget_m {
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #e83636;
          font-size: 14px;
          margin-left: 9px;
        }
      }
      .budget_btn {
        padding: 3px 12px;
        margin: 0 auto;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: #169999;
        background: rgba(22, 153, 153, 0.1);
        border-radius: 36px;
      }
    }
    .budget_active {
      flex-direction: column;
      margin-top: 0;
      .budget_mbox {
        margin-bottom: 0;
      }
      .budget_btn {
        width: 220px;
        text-align: center;
        padding: 3px 12px;
        color: #fff;
        background: #009999;
        margin: 0 auto;
        cursor: pointer;
        display: block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/print/allRequirement.vue